export default __webpack_public_path__ + "static/media/img--interiors-4.ff774812.jpg";